import { Injectable, ViewContainerRef, inject } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Observable } from "rxjs";

import { ImportColleaguesDialogComponent } from "./import-colleagues-dialog.component";

@Injectable()
export class ImportColleaguesDialogService {
  private dialog = inject(MatDialog);

  public open(viewContainerRef: ViewContainerRef): Observable<string> {
    const config = new MatDialogConfig();
    config.panelClass = ["cg-dialog", "middle"];
    config.backdropClass = "cg-dialog-backdrop";
    config.disableClose = true;
    config.viewContainerRef = viewContainerRef;

    const dialogRef = this.dialog.open(ImportColleaguesDialogComponent, config);
    return dialogRef.afterClosed();
  }
}
